import axiosPost from '../axiosPost';

export const zonasDeNoEnrollDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "ZonaNoEnrollDel",
        "params": { "zonaNoEnrollId": id }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}